export const EI_ID_TYPE = {
    NRIC: 'NRIC',
    PASSPORT: 'PASSPORT',
    BRN: 'BRN',
    ARMY: 'ARMY',
};

export const EI_ID_DROPDOWN_LIST = [
    {
        label: 'IC',
        value: EI_ID_TYPE.NRIC,
    },
    {
        label: 'Passport',
        value: EI_ID_TYPE.PASSPORT,
    },
    {
        label: 'MyTentera',
        value: EI_ID_TYPE.ARMY,
    },
];

export const EI_ERROR_CODE = {
    BAD_STRUCTURE: 'BadStructure',
    MAXIMUM_SIZE_EXCEEDED: 'MaximumSizeExceeded',
    INCORRECT_SUBMITTER: 'IncorrectSubmitter',
    DUPLICATE_SUBMISSION: 'DuplicateSubmission',
};

export const EI_STATUS = {
    SUBMITTED: 'Submitted',
    CANCELLED: 'Cancelled',

    VALID: 'Valid',

    PENDING: 'Pending',

    EXPORTED: 'Exported',

    ALL: 'All',

    NONE: 'N/A',

    INVALID: 'Invalid',
};

export const EI_STATUS_DROPDOWN_LIST = [
    {
        label: EI_STATUS.ALL,
        value: EI_STATUS.ALL,
    },
    {
        label: EI_STATUS.NONE,
        value: EI_STATUS.NONE,
    },
    {
        label: EI_STATUS.SUBMITTED,
        value: EI_STATUS.SUBMITTED,
    },
    {
        label: EI_STATUS.VALID,
        value: EI_STATUS.VALID,
    },
    {
        label: EI_STATUS.CANCELLED,
        value: EI_STATUS.CANCELLED,
    },
    {
        label: EI_STATUS.PENDING,
        value: EI_STATUS.PENDING,
    },
    {
        label: EI_STATUS.EXPORTED,
        value: EI_STATUS.EXPORTED,
    },
    {
        label: EI_STATUS.INVALID,
        value: EI_STATUS.INVALID,
    },
];

export const EI_USER_FIELDS = {
    EMAIL: 'EMAIL',
    ID: 'ID',

    TIN: 'TIN',

    ADDRESS: 'ADDRESS',
};

export const EI_USER_FIELDS_DROPDOWN_LIST = [
    {
        label: 'Email',
        value: EI_USER_FIELDS.EMAIL,
    },
    {
        label: 'ID',
        value: EI_USER_FIELDS.ID,
    },
    {
        label: 'TIN',
        value: EI_USER_FIELDS.TIN,
    },
    {
        label: 'Address',
        value: EI_USER_FIELDS.ADDRESS,
    },
];
